module.exports = __webpack_public_path__ + "img/電気回路_5_7_5.f0c2b1c2.png";